import { render, staticRenderFns } from "./StripeElements.vue?vue&type=template&id=476d27dd&scoped=true"
import script from "./StripeElements.vue?vue&type=script&lang=js"
export * from "./StripeElements.vue?vue&type=script&lang=js"
import style0 from "./StripeElements.vue?vue&type=style&index=0&id=476d27dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476d27dd",
  null
  
)

export default component.exports